import { FormattedMessage } from 'react-intl';

const RadioCheck = ({ options, name, selectedOption, disabled, onChange }) => {
    return (
        <>
            <div className="align-items-center mt-2">
                {Object.keys(options).map((key, index) => (
                    <div className="form-check form-check-inline" key={index}>
                        <input
                            className="form-check-input mes-radio"
                            type="radio"
                            name={name}
                            disabled={disabled || key === 'image'}
                            id={`${name}${index + 1}`}
                            value={key}
                            checked={selectedOption === key}
                            onChange={onChange}
                        />
                        <label className="form-check-label mes-from-label-1 me-4" htmlFor={`${name}${index + 1}`}><FormattedMessage id={options[key]} /></label>
                    </div>
                ))}
            </div>
        </>
    );
}

export default RadioCheck;